export default import.meta.ROLLUP_FILE_URL_iAVotgG_fH8uzeP$Mk35hQ